import React from 'react';
import moment from 'moment';
import { getDollarFormat } from 'utils/helpers';
import NoDataMsg from 'library/noData';

const Body = ({ auditReport, endDate, beginDate }) => (

    <div>
        {
            auditReport.length <= 0 ?
                //If there's NO DATA to display
                <NoDataMsg />
                :
                //If there's DATA
                <div>
                    <div className="row m-0">
                        <div className="text-center list_header">
                            {beginDate ?
                                <p><i>From</i> <b>{moment(beginDate).format('MMMM Do, YYYY')}</b> <i> to </i>
                                    {endDate ? <b>{moment(endDate).format('MMMM Do, YYYY')}</b> : moment().format('MMMM Do, YYYY')}</p>
                                : ""}
                        </div>
                    </div>
                    {
                        auditReport.length > 0 &&
                        <div className="table-responsive">
                            {
                                auditReport.map((item, index) => {
                                    return (
                                        <div className="row m-0 mb-2  text-center daily_cash" key={index}>
                                            <div className="row col-lg-4 col-md-4 col-sm-12 col-xs-12 m-0 p-2">
                                                <div className="col-lg-5 col-md-5 col-sm-12 col-xs-12 p-2">
                                                    <label>Audit Id</label>
                                                    <h3 className="m-0 grey-text">{item.auditId}</h3>
                                                </div>
                                                <div className="col-lg-7 col-md-7 col-sm-6 col-xs-6  p-2">
                                                    <p><label>Audit Name:</label> <span>{item.auditName}</span></p>
                                                    <p><label>Branch:</label> <span>{item.branchName}</span></p>
                                                    <p><label>Completed Date:</label> <span>{moment(item.auditCompletedDate).format('MMMM Do, YYYY')}</span></p>
                                                    <p><label>Province:</label> <span>{item.province}</span></p>
                                                </div>
                                            </div>
                                            <div className="row col-lg-5 col-md-5 col-sm-12 col-xs-12 m-0 p-0">
                                                
                                                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4  p-2">
                                                    <label>- Difference Qty</label>
                                                    <h3 className="m-0">{item.negativeDiffQty}</h3>
                                                </div>
                                                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4  p-2">
                                                    <label>+ Difference Qty</label>
                                                    <h3 className="m-0 ">{item.positiveDiffQty}</h3>
                                                </div>
                                                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4  p-2">
                                                    <label>Total Difference Qty</label>
                                                    <h3 className="m-0">{item.totalDiffQty}</h3>
                                                </div>
                                                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4  p-2">
                                                    <label>- Difference Value</label>
                                                    <h3 className="m-0">{getDollarFormat(item.negativeDiffValue)}</h3>
                                                </div>
                                                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4  p-2">
                                                    <label>+ Difference Value</label>
                                                    <h3 className="m-0 ">{getDollarFormat(item.positiveDiffValue)}</h3>
                                                </div>
                                                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4  p-2">
                                                    <label>Total Difference Value</label>
                                                    <h3 className="m-0">{getDollarFormat(item.totalDiffValue)}</h3>
                                                </div>
                                            </div>
                                            <div className="row col-lg-3 col-md-3 col-sm-12 col-xs-12 m-0 p-0">
                                                
                                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 m-0 p-0">
                                                    <label>Total Counted Qty</label>
                                                    <h3 className="m-0">{item.totalCountedQty}</h3>
                                                </div>
                                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 m-0 p-0">
                                                    <label>Total Counted Value</label>
                                                    <h3 className="m-0 ">{getDollarFormat(item.totalCountedValue)}</h3>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })
                            }
                        </div>
                    }
                </div>
        }
    </div>
);

export default Body;


